import {Component, EventEmitter, Input, Output} from '@angular/core';
import {ClientInfo} from '@shared/models/client-info.model';
import {RegisterModel} from '@shared/models/register.model';
import {environment} from '@environments/environment';
import {configVariableValues} from '@shared/constants/config-variable-values.constants';
import {LoaderService} from '@core/src/public-api';
import {ClientInfoService} from '@shared/services/client-info.service';

@Component({
  selector: 'si-register-privacy',
  templateUrl: './register-privacy.component.html',
  styleUrls: ['./register-privacy.component.scss']
})
export class RegisterPrivacyComponent {
  @Input() model = new RegisterModel();
  @Input() wideResolution: boolean;
  @Output() modelChange = new EventEmitter<RegisterModel>();
  @Output() captchaRenderedChange = new EventEmitter<boolean>();
  showPrivacy = false;
  showTerms = false;
  privacyTitle = 'SI_PRIVACY_POLICY';
  termsTitle = 'SI_LEGAL_TERMS';
  privacyModel: ClientInfo;
  termsModel: ClientInfo;
  captchaRendered: boolean;
  environment = environment;
  configVariableValues = configVariableValues;

  constructor(
    private loaderService: LoaderService,
    private clientInfoService: ClientInfoService
  ) {
  }

  async onClickShowPrivacyInformation(): Promise<void> {
    await this.getPrivacyInformation();
    this.showPrivacy = true;
  }

  async onClickShowTermsInformation(): Promise<void> {
    await this.getTermsInformation();
    this.showTerms = true;
  }

  async getPrivacyInformation(): Promise<void> {
    if (this.privacyModel) {
      return;
    }

    this.loaderService.start();
    try {
      this.privacyModel = await this.clientInfoService.getPrivacy();
    } finally {
      this.loaderService.stop();
    }
  }

  async getTermsInformation(): Promise<void> {
    if (this.termsModel) {
      return;
    }

    this.loaderService.start();
    try {
      this.termsModel = await this.clientInfoService.getTerms();
    } finally {
      this.loaderService.stop();
    }
  }

  onChangeCaptchaRendered(captchaRendered: boolean): void {
    this.captchaRendered = captchaRendered;
    this.captchaRenderedChange.emit(this.captchaRendered);
  }
}
